export const EMPLOYEE_ENGAGEMENT_DASHBOARD_PATH = '/reports/employee-engagement';

export const DATA_TABLE_PAGE_SIZE = 10;

// Maps the API's snake_case employment_status codes to display labels.
export const EMPLOYMENT_TYPE_LABELS: Record<string, string> = {
  full_time: 'Full Time',
  part_time: 'Part Time',
  casual: 'Casual',
  flex: 'Flex',
  not_sure: 'Not Sure',
  terminated: 'Terminated',
};

export const formatEmploymentStatus = (status: string): string =>
  EMPLOYMENT_TYPE_LABELS[status] ??
  status.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

export const LAST_APP_OPENED_BUCKETS = [
  'Today',
  '1-3 days',
  '4-7 days',
  '8-14 days',
  '15-30 days',
  '30+ days',
] as const;

export const LAST_APP_OPENED_BUCKET_KEYS = [
  'today',
  'days_1_3',
  'days_4_7',
  'days_8_14',
  'days_15_30',
  'days_30_plus',
] as const;

export const LAST_APP_OPENED_ALERT_BUCKET = '30+ days';

export const Y_AXIS_ROUNDING_INTERVAL = 10;

export const INLINE_BAR_MAX_WIDTH_PERCENT = 80;
export const INLINE_BAR_MIN_WIDTH = 4;
export const INLINE_BAR_HEIGHT = 14;
export const INLINE_BAR_BORDER_RADIUS = 2;

export const LAST_APP_OPENED_ALERT_COLOR = '#C62828';
